import React, { Fragment } from 'react'
import Time from 'react-times'
import ReactHtmlParser from 'html-react-parser'
import 'react-times/css/classic/default.css'

class TimePicker extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hour: '12',
      minute: '00',
      meridiem: 'AM',
      parsedTime: '00:00:00',
      focused: false
    }
    this.onTimeChange = this.onTimeChange.bind(this)
    this.onMeridiemChange = this.onMeridiemChange.bind(this)
  }

  onTimeChange(time) {
    const { storeAnswer, checkSurveyState, index } = this.props
    const [hour, minute] = time.split(':')

    this.setState({ hour, minute }, () => {
      let { hour, minute, meridiem } = this.state

      if (meridiem === 'PM') hour = parseInt(hour, 10) + 12
      const parsedTime = `${hour}:${minute}:00`

      this.setState({ parsedTime, focused: false }, () => {
        storeAnswer(index, this.state)
        checkSurveyState(this)
      })
    })
  }

  onMeridiemChange(meridiem) {
    this.setState({ meridiem })
  }

  componentDidMount() {
    const { rawAnswers, index, storeAnswer } = this.props
    if (rawAnswers) {
      this.setState(rawAnswers)
    } else {
      storeAnswer(index, this.state)
    }
  }

  render() {
    const { className, question } = this.props
    const { meridiem, hour, minute, focused } = this.state

    return (
      <div className={`${className}`}>
        <div className="surveys-intro row collapse">
          <div className="small-12 columns">
            <h3>{ReactHtmlParser(question)}</h3>
          </div>
        </div>
        <div className="row surveys-container survey-time-picker collapse">
          <div className="small-12 columns">
            <Time
              onTimeChange={this.onTimeChange}
              onMeridiemChange={this.onMeridiemChange}
              timeMode="12"
              theme="classic"
              meridiem={meridiem}
              time={hour && minute ? `${hour}:${minute}` : null}
              focused={focused}
            />
          </div>
        </div>
        {this.props.isMobile && (
          <Fragment>
            <br />
            <br />
            <br />
          </Fragment>
        )}
      </div>
    )
  }
}

export default TimePicker
